<template>
  <div class="article-detail">
    <JumpHeader />
    <div class="thumbs-wrapper" v-if="articleDetail.isPraise !== 1">
      <Thumbs :operateId="operateId" @clickThumbs="clickThumbs" />
      <div class="praise-num">{{ transNumToBig(articleDetail.plusPraiseSum) }}</div>
    </div>
    <h4 class="title">{{ articleDetail.title }}</h4>
    <div class="publish-wrapper">
      <img class="publish-img" src="~@/assets/image/icon_logo.png" alt="" />
      <div class="publish-content">
        <span>{{ articleDetail.publishName }}</span>
        <span>{{ articleDetail.plusEffectDate }}</span>
      </div>
    </div>
    <div class="intro" v-if="articleDetail.absTract">
      <div v-html="articleDetail.absTract"></div>
    </div>
    <div
      id="content"
      class="content"
      v-html="articleDetail.content"
      @click="handleClickContent"
    ></div>
    <div class="info-name">{{ articleDetail.editorName }}</div>
    <div class="info-name">{{ articleDetail.reporterName }}</div>
    <div class="info-name">{{ articleDetail.messenger }}</div>
    <div class="info-name">{{ articleDetail.commentator }}</div>
    <div class="info-name">{{ articleDetail.from }}</div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已经到底了"
      @load="commentOnLoad"
      class="article-list"
      v-if="commentList.length"
    >
      <div class="comments-wrapper">
        <div class="divider">
          <span class="divider-left"></span>
          <span class="divider-desc">全部评论</span>
          <span class="divider-left"></span>
        </div>
        <div class="comment-list">
          <div class="comment-item" v-for="item in commentList" :key="item.id">
            <div class="comment-info">
              <van-image
                width="35"
                height="35"
                class="parent-img"
                round
                :src="item.userPersonalImage"
              />
              <div class="right-info">
                <div class="nick-wrapper">
                  <span class="nickname">{{ item.userNickname }}</span>
                  <div class="like-wrapper">
                    <van-icon name="like" />
                    {{ item.praiseSum }}
                  </div>
                </div>
                <span>{{ formatMsgTime(item.publishDate) }}</span>
              </div>
            </div>
            <div class="content-info">
              {{ item.content }}
            </div>
            <div class="child-comment" v-if="item.childCommentList.length">
              <div class="child-item" v-for="child in item.childCommentList" :key="child.id">
                <div class="comment-info">
                  <van-image
                    width="30"
                    height="30"
                    class="child-img"
                    round
                    :src="child.userPersonalImage"
                  />
                  <div class="right-info">
                    <div class="nick-wrapper">
                      <span class="nickname">{{ child.userNickname }}</span>
                      <div class="like-wrapper">
                        <van-icon name="like" />
                        {{ child.praiseSum }}
                      </div>
                    </div>
                    <!-- <span class="nickname">{{ child.userNickname }}</span> -->
                    <span>{{ child.publishDate }}</span>
                  </div>
                </div>
                <div class="content-info">
                  {{ child.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div v-else>
      <div class="comments-wrapper">
        <div class="divider">
          <span class="divider-left"></span>
          <span class="divider-desc">全部评论</span>
          <span class="divider-left"></span>
        </div>
        <van-empty description="暂无评论" />
      </div>
    </div>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { ImagePreview } from "vant";
import JumpHeader from "@/components/Base/JumpHeader";
import Thumbs from "@/components/Thumbs";
import { getMobilsInfo } from "@/utils";
import ZMYDataCollection from "@/utils/zmy.js";
import {
  clickRecord,
  queryAllComments,
  previewArticle,
  queryOperateBtn,
  getCookie,
} from "@/http/api";
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "ArticleDetail",
  components: {
    Thumbs,
    JumpHeader,
  },
  data() {
    return {
      imgList: [],
      operateId: null,
      articleDetail: {},
      commentList: [],
      loading: false,
      finished: false,
      commentPageNum: 1,
      ticketId: "",
    };
  },
  async mounted() {
    if (Cookies.get("ticket-id")) {
      this.init();
    } else {
      await getCookie({ ticket: "" }).then((ticketId) => {
        console.log("ticketId", ticketId);
        this.ticketId = ticketId;
        this.init();
      });
      ZMYDataCollection.init({tenant_code:"prod-gzgb-6b45b19f05d3b092013fd6",key:"wJT7EOgGmpHClezJ2qgb1nE60RgVUnrX",domain:"rmapi.nfzmy.com",debug:"false"});

    }
    // const cookies = ticketId.headers["set-cookie"];
    // console.log("cookies", cookies);
    // Cookies.set("ticket-id", ticketId, {
    //   expires: 1 / 1440,
    // });

    // 12小时的毫秒数
    // 12 * 60 * 60 * 1000
    // let expirationDate = new Date();
    // expirationDate.setTime(expirationDate.getTime() + 10 * 1000); // 12小时的毫秒数
    // document.cookie = `ticket-id=${ticketId}; expires=` + expirationDate.toUTCString();

    // console.log("document.cookie", document.cookie);
  },
  updated() {
    let obj = document.getElementById("content");
    let imgs = obj.getElementsByTagName("img");
    if (imgs.length > 0) {
      this.imgList = [];
      for (let i = 0; i < imgs.length; i++) {
        this.imgList.push(imgs[i].src);
      }
    }
  },
  methods: {
    init() {
      this.operateId = this.$route.query.id;
      this.getPermiBtn();
      this.queryCommentData();
      this.getArticleDetail();
      this.recordData();
      ZMYDataCollection.openArticle({article_id:this.operateId,platform:"Mobile"});
    },
    async queryCommentData() {
      this.loading = true;
      const { data } = await queryAllComments({
        operateId: this.operateId,
        operateType: 1,
        pageNum: this.commentPageNum,
        pageSize: 10,
      });
      this.loading = false;
      if (this.commentPageNum >= data.pages) {
        this.finished = true;
      }
      this.commentList = [...this.commentList, ...data.records];
    },
    transNumToBig(num) {
      // if (num > 100000) {
      //   return `10万+`;
      // }
      if (num > 10000) {
        //return `${Math.floor(num / 10000)}万+`;
        return `1万+`;
      } else {
        return num;
      }
    },
    formatMsgTime(dateTimeStamp) {
      // 时间字符串转时间戳 获取毫秒数
      let timestamp = new Date(dateTimeStamp.replace(/-/g, "/")).getTime();
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let halfamonth = day * 15;
      let month = day * 30;
      let year = day * 365;
      let now = new Date().getTime();
      let diffValue = now - timestamp;
      let result;
      if (diffValue < 0) {
        return;
      }
      let yearC = diffValue / year;
      let monthC = diffValue / month;
      let weekC = diffValue / (7 * day);
      let dayC = diffValue / day;
      let hourC = diffValue / hour;
      let minC = diffValue / minute;
      if (yearC >= 1) {
        result = "" + parseInt(yearC) + "年前";
      } else if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月前";
      } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
      } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else result = "刚刚";
      return result;
    },
    commentOnLoad() {
      this.commentPageNum++;
      this.queryCommentData();
    },
    clickThumbs() {
      this.articleDetail.plusPraiseSum++;
    },

    async getArticleDetail() {
      const { data } = await previewArticle(this.operateId);
      data.absTract = data.absTract ? data.absTract.trim() : null;
      this.articleDetail = data;
      document.title = this.articleDetail.title ? this.articleDetail.title : "花城+";
      this.wxShare();
      if (data.isGray == 1) {
        import("@/assets/scss/grayfilter.css");
      }
    },

    async recordData() {
      await clickRecord({
        deviceId: "1",
        operateId: this.operateId,
        operateType: 1,
        web:1,
      });
    },

    async getPermiBtn() {
      const { data } = await queryOperateBtn({
        operateId: this.operateId,
        operateType: 1,
      });
    },

    handleClickContent(e) {
      if (e.target.nodeName === "IMG") {
        let handleImgIndex = this.imgList.findIndex((value) => {
          return value === e.target.src;
        });
        ImagePreview({
          images: this.imgList,
          startPosition: handleImgIndex,
        });
      }
    },

    wxShare() {
      const _detail = this.articleDetail;
      let sharePic = `${process.env.VUE_APP_SHARE_URL}/filedata/default/hcplusIcon.jpg`;
      if (_detail.banner != null && _detail.banner !== "") {
        sharePic = _detail.banner;
      }
      wxSdk.getJSSDK({
        title: _detail.title,
        desc: _detail.absTract ? _detail.absTract : "花城+",
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/articleDetail?id=${_detail.manuId}`,
        img: sharePic,
        operateId: this.id,
        operateType: 1,
      });
    },
  },
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.init();
          window.scrollTo(0, 0);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
/* @import "@/assets/scss/index.scss"; */
.article-detail {
  position: relative;
  /* font-size: 14px; */
  box-sizing: border-box;
  padding: 0 10px;
  margin-top: 10px;
  width: 100%;
  overflow: hidden !important;
  font-size: 18px;
  .title {
    font-size: 1.35rem;
    font-weight: 600;
    line-height: 1.65;
    margin-bottom: 15px;
    padding: 15px 15px 0;
    text-align: left;
    font-family: Microsoft YaHei !important;
  }

  .publish-wrapper {
    display: flex;
    height: 42px;
    margin-top: 15px;

    .publish-img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }

    .publish-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      box-sizing: border-box;
      padding: 2px 0;
    }
  }

  .intro {
    position: relative;
    background: #f9f9f9;
    font-size: 14px;
    padding: 15px;
    margin: 10px 0;
    border-radius: 4px;
    color: #000000;
    box-sizing: border-box;

    &::before {
      position: absolute;
      content: "“";
      top: 0;
      left: 0;
      transform: translate(-30%, -20%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }

    &::after {
      position: absolute;
      content: "”";
      bottom: 0;
      right: 0;
      transform: translate(30%, 75%);
      font-size: 32px;
      color: #bcd7e4;
      font-weight: bold;
      font-family: SimHei;
    }
  }

  .content {
    overflow-x: hidden;
    margin-top: 10px;
    width: 100%;
  }
  .content p {
    line-height: 1.75;
    margin: 0;
    padding-bottom: 1em;
  }

  .info-name {
    margin-top: 5px;
    font-size: 14px;
    color: #999;

    &:last-child {
      margin-bottom: 20px;
    }
  }

  .comments-wrapper {
    margin-top: 20px;

    .divider {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 0;

      &-left {
        width: 100px;
        height: 1px;
        background: rgba(220, 220, 220, 0.9);
        transform: scaleY(0.5);
      }

      &-desc {
        margin: 0 15px;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .comment-list {
      width: 100%;

      .comment-item {
        margin-bottom: 20px;

        .comment-info {
          display: flex;
          align-items: center;

          .parent-img {
            width: 35px;
            min-width: 35px;
            height: 35px;
            border-radius: 50%;
          }

          .right-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            height: 35px;
            color: #999;
            font-size: 12px;
            margin-left: 10px;

            .nick-wrapper {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-between;

              .nickname {
                color: #333;
                font-size: 14px;
                font-weight: bold;
              }

              .like-wrapper {
                font-size: 16px;
              }
            }
          }
        }

        .content-info {
          margin-left: 45px;
          margin-top: 5px;
          font-size: 14px;
          word-break: break-all;
        }

        .child-comment {
          margin-left: 45px;
          margin-top: 10px;
          background: #f9f9f9;
          box-sizing: border-box;
          padding: 8px;
          border-radius: 6px;

          .child-item {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }

            .comment-info {
              display: flex;
              align-items: center;

              .child-img {
                width: 30px;
                min-width: 30px;
                height: 30px;
                border-radius: 50%;
              }

              .right-info {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 30px;
                width: 100%;
                color: #999;
                font-size: 12px;
                margin-left: 10px;

                .nick-wrapper {
                  display: flex;
                  width: 100%;
                  align-items: center;
                  justify-content: space-between;

                  .nickname {
                    color: #333;
                    font-size: 14px;
                    font-weight: bold;
                  }

                  .like-wrapper {
                    font-size: 16px;
                  }
                }
              }
            }

            .content-info {
              margin-left: 45px;
              margin-top: 5px;
              font-size: 14px;
              word-break: break-all;
              color: #333;
            }
          }
        }
      }
    }
  }

  .thumbs-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 20px;
    bottom: 50px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 1px 3px 6px #bbb;
    color: #fff;
    font-size: 34px;
    z-index: 9999;
    cursor: pointer;

    .praise-num {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(25%, -25%);
      /* background: rgba(231, 56, 40, 0.6); */
      background: #bbb;
      padding: 0 8px;
      height: 20px;
      border-radius: 10px;
      font-size: 12px;
      color: #fff;
    }
  }

  @media screen and (min-width: 768px) {
    .thumbs-wrapper {
      left: 50%;
      transform: translateX(290px);
    }
  }
}
</style>
